import { StringReplacePipe } from '../../../../../_helpers/_pipes/string-replace.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output , NO_ERRORS_SCHEMA, AfterViewInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { BillingPolicy } from '../add-billing/add-billing.component';
import { FormControl, FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, StringReplacePipe],
  selector: 'app-billing-details-header',
  templateUrl: './billing-details-header.component.html',
  styleUrls: ['./billing-details-header.component.scss']
})
export class BillingDetailsHeaderComponent implements OnInit, AfterViewInit {

  @Input() billingPolicyData: BillingPolicy;
  @Input() displayName: string;
  @Output() selectPolicy: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('measureHelper') measureHelper?: ElementRef<HTMLElement>;
  @ViewChild('ngSelectHost', { read: ElementRef }) ngSelectHost?: ElementRef<HTMLElement>;
  isAcmic: boolean;
  billingPolicySelectForm: FormGroup;
  company: string;
  colWidths: number[] = [0, 0, 0];
  selectHostWidth: number | null = null;

  constructor(
    private acmicServide: AcmicService,
    private cdr: ChangeDetectorRef
  ) { 
    this.isAcmic = this.acmicServide.isACMIC();
  }

  onPolicySelect() {
    this.selectPolicy.emit(this.billingPolicySelectForm.controls.selectedPolicy.value);
  }
  ngOnInit(): void {
    this.billingPolicySelectForm = new FormGroup({
      selectedPolicy: new FormControl(null)
    });
    this.billingPolicySelectForm.controls.selectedPolicy.setValue(this.billingPolicyData?.displayName);
  }

  ngAfterViewInit(): void {
    if (this.isAcmic) {
      return;
    }
    setTimeout(() => this.measureColumnWidths());
  }

  private measureColumnWidths(): void {
    if (this.isAcmic || !this.measureHelper) {
      return;
    }
    const rows = this.measureHelper.nativeElement.querySelector('.measure-row');
    const cells = rows.querySelectorAll<HTMLElement>('.measure-cell')
    this.colWidths = Array.from(cells).map(cell => cell.getBoundingClientRect().width)
    this.cdr.detectChanges();

    setTimeout(() => this.syncHostWidthToPanel());
  }

  private syncHostWidthToPanel(): void {
    const hostEl: HTMLElement = this.ngSelectHost.nativeElement;
    this.selectHostWidth = hostEl.getBoundingClientRect().width;
    this.cdr.detectChanges();
  }

  
  isV12OrAS400Company(): boolean {
    return this.company === 'V12' || this.company === 'AS400';
  }

  getPolicyTypeLabel(name: string): string {
    return (name || '').split('-')[0]?.trim() || '';
  }

  getPolicyNumberSuffix(name: string): string {
    const policyNumber = (name || '').split('-').slice(1).join('-').trim();
    if (!policyNumber) {
      return '';
    }
    const formattedPolicyNumber = this.isV12OrAS400Company() && /[a-zA-Z]/.test(policyNumber)
      ? policyNumber.toUpperCase()
      : policyNumber;
    return `${formattedPolicyNumber}`;
  }

  toSentenceCase(value: string): string {
    const normalized = (value || '').trim();
    if (!normalized) {
      return '';
    }
    const lowerValue = normalized.toLowerCase();
    if (lowerValue === 'auto' || lowerValue === 'property') {
      return lowerValue;
    }
    return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
  }


}
